var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full "},[_c('div',{staticClass:"contnet "},[(_vm.items)?_c('PrtMap',{staticClass:"border",attrs:{"items":_vm.items}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }